import { AuthContextData, User } from '@/types/auth'
import { useKeycloak } from '@react-keycloak/web'
import { ReactNode, createContext, useEffect, useState } from 'react'
import { Loading } from '@/components/Loading'

type AuthProviderProps = {
  children: ReactNode
}

export const AuthContext = createContext({} as AuthContextData)

export function AuthProvider({ children }: AuthProviderProps) {
  const { keycloak, initialized } = useKeycloak()
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      setIsAuthenticated(true)
    }
  }, [initialized, keycloak.authenticated])

  const user: User = {
    id: keycloak.tokenParsed?.sub || '',
    name: keycloak.tokenParsed?.name || '',
    email: keycloak.tokenParsed?.email || '',
    emailVerified: keycloak.tokenParsed?.email_verified || false,
  }

  if (!initialized) {
    return <Loading />
  } else {
    return <AuthContext.Provider value={{ isAuthenticated, user }}>{children}</AuthContext.Provider>
  }
}
